import React, { useState, useEffect, useContext, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import { VehiclesContext } from '../contexts/VehiclesContext';

import Traductor from '../components/Traductor';
import Button from '../components/bronson/Button';
import SellService from '../services/SellService';
import { UserContext } from '../contexts/UserContext';
import { withCookies } from 'react-cookie';
import Globals from '../Globals';

import { getWSService } from '../js/WebSocketService';
import PreferenceModule from '../components/PreferenceModule';
import CustomMessage from '../components/shared/CustomMessage';
import Loading from '../components/bronson/Loading';
import { Compare, throttle } from 'Functions';

import UserService from '../services/UserService';
import ParseService from '../services/ParseService';
import ScrollToTop from '../components/ScrollToTop';

import Carousel from 'components/bronson/Carousel';
import CardBody from 'components/auctions/AuctionVehicleCard/Body';
import CardHeader from 'components/auctions/AuctionVehicleCard/Header';
import VehicleTotalPrice from 'components/shared/VehicleTotalPrice';

import usePermissions from 'hooks/usePermissions';
import { READONLY_PERMISSION } from 'constants/Permissions';
import ToastNotification from 'components/bronson/ToastNotification';

function DirectPurchasePage({ type, history, cookies }) {
    const t = useMemo(() => new Traductor(), []);
    const { checkPermission } = usePermissions();
    const { user, preferences, setPreferences } = useContext(UserContext);
    const { contextDirectPurchaseRefresh, selectedVehicle } = useContext(
        VehiclesContext
    );
    const optionsButtonGoBack = {
        btnTypes: ['link', 'small', 'simple'],
        icon: {
            isBeforeText: true,
            isAfterText: false,
            image: 'semantic-back',
        },
        text: t.getTraduction('VolverAlListado'),
    };
    const [innerWidth, setInnerWith] = useState(window.innerWidth);
    const [isBuyed, setIsBuyed] = useState(false);
    const [errorRequest, setErrorRequest] = useState({});
    const [showToast, setShowToast] = useState(null);

    /* BuyerDataModule */
    const [loading, setLoading] = useState(false);
    const [TransportCampaDestiny, setTransportCampaDestiny] = useState('');
    const [CheckPredeterminated] = useState(false);
    const [dataTerm, SetDataTerm] = useState(0);
    const [dataTransportprice, SetdataTransportprice] = useState(null);
    const [validateForm, setValidateForm] = useState(false);

    useEffect(() => {
        if (selectedVehicle == null || !selectedVehicle.Id) history.goBack();
        window.addEventListener('resize', updateDimensions);
    }, [history, selectedVehicle]);

    useEffect(() => {
        if (
            selectedVehicle?.WebSalesId &&
            contextDirectPurchaseRefresh.IdVehicle ===
                selectedVehicle.WebSalesId &&
            !isBuyed
        ) {
            setErrorRequest({
                title: t.getTraduction('MessageOops_buyed_title'),
                body: t.getTraduction('MessageOops_buyed_body'),
            });
        }
    }, [
        contextDirectPurchaseRefresh.IdVehicle,
        contextDirectPurchaseRefresh.counter,
        isBuyed,
        selectedVehicle,
        t,
    ]);

    let optionsBtnSaveDirect = {
        text: t.getTraduction('BuyVehicle'),
        disabled:
            checkPermission(READONLY_PERMISSION) || loading ? true : false,
        value: 'Guardar Compra directa',
        id: 'btnSavePreferences',
        class:
            innerWidth < 720
                ? 'u-mt u-mb-xlarge c-btn--full'
                : 'u-mt-xsmall u-mb-xlarge',
    };

    const onClickButtonGoBack = () => {
        history.goBack();
    };

    const sendMessageAWS = () => {
        const model = {
            Vehicles: [selectedVehicle?.WebSalesId],
        };
        getWSService().sendMessage('onMessage', MensajeWebSocket(model));
    };
    const MensajeWebSocket = msg => {
        var obj = {};
        obj.type = 'directPurchase';
        obj.data = msg;
        return obj;
    };

    const updateDimensions = () => {
        setInnerWith(window.innerWidth);
    };

    const onClickSavePreferences = () => {
        setValidateForm(true);
        setLoading(true);
    };

    const onResetPreferences = bolean => {
        setValidateForm(bolean);
    };

    const updateDataTransport = DataTransportprice => {
        //setDisabledBotonDirectBuy(true);
        SetDataTerm(DataTransportprice.Term);
        setTransportCampaDestiny(DataTransportprice.DestinationLocationId);
        if (DataTransportprice.TransportPrice < 0) {
            DataTransportprice.TransportPrice = null;
        }
        SetdataTransportprice(DataTransportprice.TransportPrice);
    };

    /* Buyer data module NUEVO */
    const buyVehicle = async (data, disableAmazon) => {
        await new SellService()
            .buyVehicle(data, cookies.get(Globals.COOKIES.JWT).AccessToken)
            .then(response => {
                if (
                    response &&
                    response.statusCode === 200 &&
                    response.body.Result !== null &&
                    response.body.Result === 'true'
                ) {
                    setIsBuyed(true);
                    sendMessageAWS();
                    goToTop();
                    if (data?.idVehicleWebSales) {
                        if (disableAmazon) {
                            new SellService().dumpVehicles(
                                [data.idVehicleWebSales],
                                cookies.get(Globals.COOKIES.JWT).AccessToken,
                                process.env.REACT_APP_AWS_DUMP_VEHICLES,
                                process.env.REACT_APP_AWS_BIDS_APIKEY_NAME,
                                process.env.REACT_APP_AWS_BIDS_APIKEY_VALUE
                            );
                        }
                    }
                } else {
                    let body = t.getTraduction('MessageOops_body');
                    if (
                        response &&
                        response.body &&
                        response.body.Errors &&
                        response.body.Errors.length > 0
                    ) {
                        body = response.body.Errors[0].Value;
                    }
                    setErrorRequest({
                        title: t.getTraduction('MessageOops_title'),
                        body,
                    });
                }
            });
        setLoading(false);
    };

    const buyVehicleDealerReceptor = async data => {
        await new SellService()
            .buyVehicleDealerReceptor(
                data,
                cookies.get(Globals.COOKIES.JWT).AccessToken
            )
            .then(response => {
                if (
                    response &&
                    response.statusCode === 200 &&
                    response.body.Result != null &&
                    response.body.Result === 'true'
                ) {
                    setIsBuyed(true);
                    goToTop();
                } else {
                    let body = t.getTraduction('MessageOops_body');
                    if (
                        response &&
                        response.body &&
                        response.body.Errors &&
                        response.body.Errors.length > 0
                    ) {
                        body = response.body.Errors[0].Value;
                    }
                    setErrorRequest({
                        title: t.getTraduction('MessageOops_buyed_error_title'),
                        body,
                    });
                }
                setLoading(false);
            });
    };

    const goToTop = () => {
        window.scrollTo(0, 0);
    };

    const savePreferences = async data => {
        if (data.PreferenceId === 0 || !Compare(preferences, data)) {
            await new UserService()
                .savePreferences(
                    cookies.get(Globals.COOKIES.JWT).AccessToken,
                    data
                )
                .then(response => {
                    if (response && response.Result) {
                        let preferenceResponse = new ParseService().Parse(
                            response.Result
                        );
                        if (preferenceResponse) {
                            data.PreferenceId = preferenceResponse.PreferenceId;
                            data.TransportId = preferenceResponse.TransportId;
                            setPreferences(data);
                        }
                        setShowToast({ title: '¡Guardado!', text: 'Preferencia guardada correctamente', type: 'success', closeText: 'Cerrar', timeout: false });
                    } else {
                        setShowToast({ title: '¡Error!', text: 'No se ha podido guardar la preferencia', type: 'error', closeText: 'Cerrar', timeout: false });
                    }
                });
        }
    };

    const purchaseVehicle = throttle(dataTransport => {
        if (dataTransport != null) {
            let installationSelect = document.getElementById(
                'Installation-select-element'
            );
            let destinationName = '';
            if (installationSelect)
                destinationName =
                    installationSelect.options[installationSelect.selectedIndex]
                        .text;
            let destination = {};

            if (selectedVehicle.WebSalesId || selectedVehicle.RepurchaseObligation >= 0) {
                destination = {
                    Name: destinationName,
                    UbicationId: dataTransport.CodconsesionarierBuyer,
                    UbicationType: 3,
                    LocationId: TransportCampaDestiny,
                    AddressType: dataTransport.StreetType,
                    Address: dataTransport.StreetName,
                    AddressNumber: dataTransport.StreetNumber,
                    PostalCode: dataTransport.ZipCode,
                    ProvinceCode: dataTransport.ZipCode ? dataTransport.ZipCode.substring(0, 2) : '',
                    MunicipalityCode: dataTransport.CodePoblation,
                    ProvinceName: dataTransport.ProvinceName,
                };
            }

            let installationExpositionSelect = document.getElementById(
                'InstallationExposition-select-element'
            );
            let installationExpositionDescription = '';
            if (installationExpositionSelect)
                installationExpositionDescription =
                    installationExpositionSelect.options[
                        installationExpositionSelect.selectedIndex
                    ].text;

            let userCifs = [...user.cifs];
            let buyerData = userCifs.find(
                x => x.CIF === dataTransport.CifBuyer
            );
            let BuyData = {
                SalesPrice: selectedVehicle?.Price,
                BrandInformeCode: dataTransport.BrandCode,
                DealerVWFInformeCode: dataTransport.CodconsesionarieEstadistics,
                DealerVWFInformeDescription: installationExpositionDescription,
                Term: dataTerm ?? 0,
                TransportPrice: dataTransportprice,
                Destination: destination,
                BuyerData: buyerData,
                EmployeId: user.data ? user.data.Empleado.Id : null,
                ProfileId: user.data ? user.data.Profile : null,
            };

            if (selectedVehicle.WebSalesId) {
                let data = {
                    idVehicleWebSales: selectedVehicle.WebSalesId,
                    BuyData: BuyData,
                    AuctionType: 2,
                };
                buyVehicle(data, selectedVehicle?.WebSalesId);
                if (CheckPredeterminated) {
                    savePreferences(dataTransport);
                }
            } else if (selectedVehicle.RepurchaseObligation >= 0) {
                let data = {
                    Vehicle: selectedVehicle,
                    BuyData: BuyData,
                    AuctionType: 6,
                };
                buyVehicleDealerReceptor(data);
            }
        } else {
            setLoading(false);
        }
    }, 500);

    const redirectToAdjudications = () => {
        history.push('/adjudications');
    };

    const printPreference = () => {
        if (
            selectedVehicle == null ||
            Object.keys(selectedVehicle).length === 0
        )
            return null;
        if (Object.keys(errorRequest).length > 0) {
            return (
                <CustomMessage
                    history={history}
                    options={{
                        title: errorRequest.title,
                        body: errorRequest.body,
                        icon: 'checkout',
                        primaryButton: {
                            options: {
                                btnTypes: [],
                                text: t.getTraduction('VolverAlListado'),
                            },
                            onClick: onClickButtonGoBack,
                        },
                    }}
                />
            );
        } else if (isBuyed) {
            return (
                <CustomMessage
                    history={history}
                    options={{
                        title: selectedVehicle.WebSalesId
                            ? t.getTraduction('ReserveMade_title')
                            : t.getTraduction('PurchaseMade_title'),
                        body: t.getTraduction('PurchaseMade_body'),
                        icon: 'success',
                        primaryButton: {
                            options: {
                                btnTypes: [''],
                                text: t.getTraduction('GoToMyVehicles'),
                            },
                            onClick: redirectToAdjudications,
                        },
                        secondaryButton: {
                            options: {
                                btnTypes: ['secondary'],
                                text: t.getTraduction('VolverAlListado'),
                            },
                            onClick: onClickButtonGoBack,
                        },
                    }}
                />
            );
        } else {
            return (
                <PreferenceModule
                    data={preferences}
                    options={{
                        button: {
                            function: purchaseVehicle,
                            reset: onResetPreferences,
                        },
                        transport: {
                            selectedVehicle: selectedVehicle,
                            getTransport: true,
                            function: updateDataTransport,
                            userHasTransportAvailable: selectedVehicle.RepurchaseObligation
                                ? false
                                : user.cifs[0] &&
                                  !user.cifs[0].IsParticipada &&
                                  user.cifs[0].CIF.toUpperCase() !==
                                      'A15011745',
                        },
                    }}
                    parentSubmit={validateForm}
                ></PreferenceModule>
            );
        }
    };

    const printVehicleCard = () => {
        if (
            (isBuyed && innerWidth < 720) ||
            (Object.keys(errorRequest).length > 0 && innerWidth < 720) ||
            selectedVehicle == null ||
            Object.keys(selectedVehicle).length === 0
        )
            return null;

        const optionsCarousel = {
            id: 'c-vehicle-card__carousel-' + selectedVehicle.Id,
            next: true,
            images: [selectedVehicle.ImageSource],
            flickity: {
                imagesLoaded: false,
            },
        };

        const vehicle = {
            ...selectedVehicle,
            Model:
                typeof selectedVehicle?.Model === 'string'
                    ? selectedVehicle.Model
                    : selectedVehicle?.Model?.Description,
            Brand:
                typeof selectedVehicle?.Brand === 'string'
                    ? selectedVehicle.Brand
                    : selectedVehicle?.Brand?.Description,
        };

        return (
            <article
                id={'card-vehicle-' + vehicle.Id}
                className={
                    'c-card c-card--image c-vehicle-card u-text-left u-pb'
                }
            >
                <div className="c-vehicle-card__carousel-container">
                    <Carousel
                        options={optionsCarousel}
                        onClickFunction={() => null}
                    />
                </div>
                <CardHeader
                    vehicle={vehicle}
                    onShowDetail={() => null}
                    loading={false}
                    countDownStatus={null}
                    hideTrolley={true}
                />
                <CardBody vehicle={vehicle} translations={t} />
                <footer className="c-card__footer u-pt-none u-pb-none">
                    <VehicleTotalPrice
                        vehicle={vehicle}
                        transportPrice={dataTransportprice}
                    />
                </footer>
            </article>
        );
    };

    return (
        <div
            className="u-pb-small  u-rema-full-height"
            data-testid="directPurchasePageTestId"
            id={'direct-purchase-page-container'}
        >
            <div className="o-page-wrap o-page-wrap--xsmall">
                <ScrollToTop></ScrollToTop>
                <div className="o-layout">
                    <div className="o-layout__item u-1/1">
                        <Button
                            onClick={onClickButtonGoBack}
                            options={optionsButtonGoBack}
                        ></Button>
                    </div>
                    <div className="o-layout__item u-3/4 u-2/3@l u-1/1@s u-mt-large">
                        <div className="o-layout">
                            <div className={'o-layout__item u-1/1'}>
                                {printPreference()}
                                {!isBuyed &&
                                Object.keys(errorRequest).length === 0 &&
                                innerWidth > 720 ? (
                                    <Button
                                        options={optionsBtnSaveDirect}
                                        onClick={onClickSavePreferences}
                                    ></Button>
                                ) : null}
                            </div>
                        </div>
                    </div>
                    <div className="o-layout__item u-1/4 u-1/3@l u-1/1@s u-mt">
                        {printVehicleCard()}
                        {!isBuyed &&
                        Object.keys(errorRequest).length === 0 &&
                        innerWidth < 720 ? (
                            <Button
                                options={optionsBtnSaveDirect}
                                onClick={onClickSavePreferences}
                            ></Button>
                        ) : null}
                    </div>
                </div>
            </div>
            <Loading ariaBusy={loading}></Loading>
            {showToast && <ToastNotification options={showToast} closeToast={() => setShowToast(null)} />}
        </div>
    );
}

export default withCookies(withRouter(DirectPurchasePage));
